import { render, staticRenderFns } from "./TipTransfer.vue?vue&type=template&id=cd747154&scoped=true&"
import script from "./TipTransfer.vue?vue&type=script&lang=js&"
export * from "./TipTransfer.vue?vue&type=script&lang=js&"
import style0 from "./TipTransfer.vue?vue&type=style&index=0&id=cd747154&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd747154",
  null
  
)

export default component.exports